import React, { useState, useEffect } from 'react';
import { Link, useParams } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import Select, { components } from "react-select";
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import { Badge } from "react-bootstrap";
import swal from "sweetalert2";
import Edit from '../../../modal/Purchase_Management/Manage_Purchase/PriceEntryModal';
import FileUpload from "react-material-file-upload";
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';


const AmountEntry = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const sno = queryParams.get('data');
  // const { sno } = useParams();
  const baseURL = process.env.REACT_APP_API_BASE_URL;    
  const branch_id = parseInt(localStorage.getItem("branch_id"), 10); 
  const user_id = parseInt(localStorage.getItem("user_id"), 10);
  const [purchase, setPurchase] = useState(null);
  const [rawMaterials, setRawMaterials] = useState([]); 
  const [open, setOpen] = useState(false);
  const [modalType] = useState("");
  const [files, setFiles] = useState([]);
  const [validationErrors, setValidationErrors] = useState({});
  const [verificationReason, setVerificationReason] = useState(''); 
  const [discountAmount, setDiscountAmount] = useState(0);
  const [gstAmount, setGstAmount] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);

  useEffect(() => {
    if (sno) {
      fetch(`${baseURL}/purchases/${sno}`)
        .then(res => res.json())
        .then(data => {
          if (data.data) {
            setPurchase(data.data);
          } else {
            setPurchase(null);
          }
        })
        .catch(err => {
          console.error("Failed to fetch purchase:", err);
          setPurchase(null);
        });
    }
  }, [sno, baseURL]);

useEffect(() => {
  if (purchase && purchase.raw_material) {
    const updated = purchase.raw_material.map(item => {
      const qty = Number(item.actual_quantity);
      const price = Number(item.actual_price);
      const isValid = qty > 0 && price > 0;

      return {
        ...item,
        actual_quantity: item.actual_quantity ?? "",
        actual_price: item.actual_price ?? "",
        checked: isValid,
        amount_status: item.amount_status !== undefined ? Number(item.amount_status) : 3, 
      };
    });

    setRawMaterials(updated);
    setVerificationReason(purchase.verification_reason ?? "");

    // NEW: Set discount, gst and amounts
    setDiscount(purchase.discount ?? 0);
    setGst(purchase.gst ?? 0);
    setDiscountAmount(purchase.discount_amount ?? 0);
    setGstAmount(purchase.gst_amount ?? 0);
    setTotalAmount(purchase.total_amount ?? 0);
  }
}, [purchase]);


  const handleFileChange = (newFiles) => {
    setFiles(prevFiles => {
      const combinedFiles = [...prevFiles, ...newFiles];
      return combinedFiles.slice(0, 4);
    });
  };

  const handleSelectAll = (e) => {
    const isChecked = e.target.checked;
    const updated = rawMaterials.map(item => ({ ...item, checked: isChecked }));
    setRawMaterials(updated);
  };

  const handleCheckboxChange = (index) => {
    const updated = [...rawMaterials];
    updated[index].checked = !updated[index].checked;
    setRawMaterials(updated);
  };

 
const handleQuantityChange = (index, value) => {
  const updated = [...rawMaterials];
  const number = parseFloat(value);

  if (value.length > 10 || number < 0 || isNaN(number)) {
    setValidationErrors(prev => ({
      ...prev,
      [`quantity-${index}`]: 'Enter a valid, non-negative number (max 10 digits)'
    }));
  } else {
    delete validationErrors[`quantity-${index}`];
    setValidationErrors({ ...validationErrors });
  }

  updated[index].actual_quantity = value;
  setRawMaterials(updated);
};

 

const handlePriceChange = (index, value) => {
  const updated = [...rawMaterials];
  const number = parseFloat(value);

  if (value.length > 10 || number < 0 || isNaN(number)) {
    setValidationErrors(prev => ({
      ...prev,
      [`price-${index}`]: 'Enter a valid, non-negative number (max 10 digits)'
    }));
  } else {
    delete validationErrors[`price-${index}`];
    setValidationErrors({ ...validationErrors });
  }

  updated[index].actual_price = value;
  setRawMaterials(updated);
};

const [reasonRequired, setReasonRequired] = useState(false);
  

const ConfirmationModal = async () => {
  const totalRawMaterialCount = rawMaterials.length;
  const selectedItems = rawMaterials.filter(item => item.checked);

  const hasInvalidItems = selectedItems.some(item =>
    isNaN(parseFloat(item.actual_quantity)) ||
    isNaN(parseFloat(item.actual_price))
  );

  const hasZeroedItems = selectedItems.some(item =>
    Number(item.actual_quantity) === 0 &&
    Number(item.actual_price) === 0
  );

  if (hasInvalidItems) {
    await swal.fire({
      icon: 'error',
      title: 'Invalid Inputs',
      text: 'Please enter valid actual quantity and price for all selected raw materials.'
    });
    return;
  }

  // 🟢 Case 1: Not all checked → reason required
  if (selectedItems.length !== totalRawMaterialCount && verificationReason.trim() === "") {
    await swal.fire({
      icon: 'warning',
      title: 'Reason Required',
      text: 'Please provide a verification reason if not all raw materials are updated.'
    });
    return;
  }

  // 🟢 Case 2: Zeroed items → reason required
  if (hasZeroedItems && verificationReason.trim() === "") {
    await swal.fire({
      icon: 'warning',
      title: 'Reason Required',
      text: 'Verification reason is required for items with actual price and quantity as 0.'
    });
    return;
  }

  // 🟢 Case 3: All checked → bill required
  if (selectedItems.length === totalRawMaterialCount && files.length === 0) {
    await swal.fire({
      icon: 'warning',
      title: 'Bill Required',
      text: 'Please upload at least one bill when all raw materials are verified.'
    });
    return;
  }

  const result = await swal.fire({
    title: 'Confirm Verification',
    text: 'Are you sure you want to verify this purchase?',
    icon: 'question',
    showCancelButton: true,
    confirmButtonText: 'Yes',
    cancelButtonText: 'Cancel'
  });

  if (!result.isConfirmed) return;

  try {
    const formData = new FormData();

    formData.append("verification_reason", verificationReason.trim());
    formData.append("discount", discountPercentage);
    formData.append("gst", gstPercentage);
    formData.append("discount_amount", computedDiscountAmount.toFixed(2));
    formData.append("gst_amount", computedGstAmount.toFixed(2));
    formData.append("total_amount", computedTotalAmount.toFixed(2));  
    formData.append('updated_by', user_id);
    selectedItems.forEach((item, index) => {
      formData.append(`raw_material[${index}][raw_material_id]`, item.raw_material_id ?? item.id);
      formData.append(`raw_material[${index}][actual_quantity]`, parseFloat(item.actual_quantity));
      formData.append(`raw_material[${index}][actual_price]`, parseFloat(item.actual_price));
      formData.append(`raw_material[${index}][amount_status]`, item.amount_status ?? 3);
      // formData.append(`raw_material[${index}][amount_status]`, item.amount_status === 3 ? null : item.amount_status);

    });

    // Append files only if uploaded
    files.forEach((file) => {
      formData.append("bill[]", file);
    });

    const res = await fetch(`${baseURL}/manage-purchase/verify/${sno}`, {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: formData
    });

    const data = await res.json();

    if (res.ok && (data.success || data.message)) {
      
      navigate('/manage-purchase', {
          state: { toastMessage: 'Purchase verified Successfully!', toastType: 'success' }
      });
    } else {
       navigate('/manage-purchase', {
          state: { toastMessage: 'Error Verifing Purchase', toastType: 'error' }
      });
    }
  } catch (err) {
    console.error(err);
    navigate('/manage-purchase', {
        state: { toastMessage: 'Error Verifing Purchase', toastType: 'error' }
    });
  }
};


  const actualTotal = rawMaterials
    .filter(item => item.checked && !isNaN(item.actual_price))
    .reduce((sum, item) => sum + parseFloat(item.actual_price || 0), 0);


const [discount, setDiscount] = useState('');
const [gst, setGst] = useState('');

const discountPercentage = parseFloat(discount) || 0;
const gstPercentage = parseFloat(gst) || 0;
 
const computedDiscountAmount = (actualTotal * discountPercentage) / 100;
const computedGstAmount = ((actualTotal - computedDiscountAmount) * gstPercentage) / 100;
const computedTotalAmount = actualTotal - computedDiscountAmount + computedGstAmount;

const [amountStatus, setAmountStatus] = useState(null);
 

const handleAmountStatusChange = (index, value) => {
  const updated = [...rawMaterials];
  updated[index].amount_status = value;
  setRawMaterials(updated);
};

  return (
    <>
      <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0">
        <div className='mb-0'>
          <h4 className='breadcrumb-header'>Purchase Verification</h4>
          <ol className="breadcrumb fs-7">
            <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
            <li className="breadcrumb-item">Purchase Management</li>
            <li className="breadcrumb-item active"><Link to='/manage-purchase'>Manage Purchase</Link></li>
          </ol>
        </div>
      </div>

      {purchase && (
        <div className="row mb-2">
          <div className="col-lg-3 mb-4">
            <label className="text-black font-w500 fs-7">Purchase Date</label>
            <div><label className='text-black fs-7 fw-bold'>{purchase.purchase_date}</label></div>
          </div>
          <div className="col-lg-3 mb-4">
            <label className="text-black font-w500 fs-7">Vendor</label>
            <div><label className='text-black fs-7 fw-bold'>{purchase.vendor_businessname}</label></div>
          </div>
          <div className='col-lg-3 mb-4'>
            <label className='text-gray-800 font-w500 fs-7'>Purchase ID</label>
            <p className='text-danger font-w600 fs-6'>{purchase.purchase_id}</p>
          </div>
        </div>
      )}

      {open && modalType === "Edit" && (
        <Edit show={open} onClose={() => setOpen(false)} />
      )}

      <div className="table-container">
        <table className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
          <thead>
            <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
              <th>
                Select All
                <div className="form-check custom-checkbox">
                  <input type="checkbox" className="form-check-input me-3" onChange={handleSelectAll} />
                </div>
              </th>
              <th>Raw Material / Base Cost</th>
              <th>Brand</th>
              <th>Qty / Units</th>
              <th className='text-center'>Actual Qty</th>
              <th>Estimated Amount</th>
              <th className='text-center'>Actual Amount</th>
              <th className='text-center'>Amount Verify</th>
            </tr>
          </thead>
          <tbody className="text-gray-600 fw-semibold fs-7">
            {rawMaterials.length > 0 ? rawMaterials.map((material, index) => (
              <tr key={material.raw_material_id || material.id}>
                <td>
                  <div className="form-check custom-checkbox">
                    <input type="checkbox" className="form-check-input me-3"
                      checked={material.checked}
                      onChange={() => handleCheckboxChange(index)}
                    />
                  </div>
                </td>
                <td>
                  <label className='text-black font-w400 fs-7'>{material.rawmaterial_name}</label>
                  <div>
                    <label className='text-info fs-7 fw-bold'>₹ {material.base_cost} /-</label>
                    (<span>{material.rawmaterial_quantity} {material.unitslug_name}</span>)
                  </div>
                </td>
                <td>{material.brand || "—"}</td>
                <td>{material.quantity} {material.unitslug_name}</td>
                <td className='text-center'> 
                    <input
                    type="text"
                    maxLength="10"
                    className="form-control text-black font-w500"
                    placeholder="Enter Actual Quantity"
                    value={material.actual_quantity}
                    onChange={(e) => handleQuantityChange(index, e.target.value)}
                    />
                    {validationErrors[`quantity-${index}`] && (
                    <span className="text-danger fs-7">{validationErrors[`quantity-${index}`]}</span>
                    )}


                </td>
                <td>
                  <Badge bg="danger" className='text-white fs-7 py-0 px-1'>
                    ₹ {material.total_cost}
                  </Badge>
                </td>
                <td className='text-center'> 
                    <input
                        type="text"
                        maxLength="10" 
                        className="form-control text-black font-w500"
                        placeholder="Enter Actual Amount"
                        value={material.actual_price}
                        onChange={(e) => handlePriceChange(index, e.target.value)}
                        />
                        {validationErrors[`price-${index}`] && (
                        <span className="text-danger fs-7">{validationErrors[`price-${index}`]}</span>
                        )}


                </td>
                 <td>
                    <div className='col-lg-6'>
                      {/* <Select
                        options={[
                          { value: 3, label: 'Select Option' },
                          { value: 0, label: 'Excluded' },
                          { value: 1, label: 'Included' },
                        ]}
                        onChange={(selectedOption) => handleAmountStatusChange(index, selectedOption?.value)}
                        value={
                          rawMaterials[index].amount_status === 0
                            ? { value: 0, label: 'Excluded' }
                            : rawMaterials[index].amount_status === 1
                            ? { value: 1, label: 'Included' }
                            : { value: 3, label: 'Select Option' }  
                        }
                        placeholder="Select Option"
                        isClearable={false}  
                      /> */}
                     <Select
                        options={[
                          { value: 3, label: 'Select Option' },
                          { value: 0, label: 'Excluded' },
                          { value: 1, label: 'Included' },
                        ]}
                        onChange={(selectedOption) => handleAmountStatusChange(index, selectedOption?.value)}
                        value={
                          [
                            { value: 3, label: 'Select Option' },
                            { value: 0, label: 'Excluded' },
                            { value: 1, label: 'Included' },
                          ].find(opt => opt.value === Number(material.amount_status)) // convert string to number
                        }
                        placeholder="Select Option"
                        isClearable={false}
                      />



                    </div>
                  </td>



              </tr>
            )) : (
              <tr>
                <td colSpan="7" className="text-center text-muted py-3">No raw materials found.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <div className='row mt-2'>
        <div className='col-lg-6 mb-2'>
          <label className='fs-6 text-black'>
            <span className='text-danger'>*</span>All the Checkbox should be checked (if not give reason)
          </label>
          {/* <textarea rows={8} className="form-control" name="comment" placeholder="Enter Reason"></textarea> */}
      <textarea
  value={verificationReason}
  onChange={(e) => setVerificationReason(e.target.value)}
  className="form-control"
  placeholder="Enter verification reason"
/>

  {reasonRequired && verificationReason.trim() === "" && (
    <span className="text-danger small">
      * Reason is required if not all items are verified or some are set to 0
    </span>
  )}

        </div>
      </div>

      <div className='d-flex justify-content-between gap-5 mt-5'>
      
        <div className='col-lg-7'>
            <div className='text-black font-w500 fs-5'>Upload Bill<span className='text-danger'>*</span></div>  
                <FileUpload 
                    maxFiles={4}  
                    value={files} 
                    onChange={(newFiles) => setFiles(newFiles)} 
                />
            </div>


        <div className='col-lg-3'>
          <div className='row'>
            <div className='col-lg-12 d-flex justify-content-between mb-2'>
              <div className='text-black font-w500 fs-5'>No of Raw Material</div>
              <div className='text-black font-w500 fs-4'>{rawMaterials.length}</div>
            </div>
       
            <div className='col-lg-12 d-flex justify-content-between mb-2'>
           <div className='text-black font-w500 fs-4'>Estimated Amount</div>
            <label className='text-black font-w500 fs-4'>
            ₹ {purchase?.estimate_amount != null
                ? Number(purchase.estimate_amount).toLocaleString('en-IN', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                    })
                : '—'}
            </label>
            </div>

            <div className='col-lg-12 d-flex justify-content-between mb-4'>
            <label className='text-black font-w500 fs-5'>Actual Amount</label>
            <label className='text-black font-w500 fs-4'>
                ₹ {actualTotal.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
            </label>
            </div>
 
            <div className='col-lg-12 d-flex justify-content-between mb-4'>
                <label className='text-black font-w500 fs-5'>Discount (%)</label>
                <input
                    type="number"
                    min="0"
                    className="form-control text-end text-black font-w500"
                    style={{ width: '30%' }}
                    placeholder="Discount"
                    value={discount}
                    onChange={(e) => {
                    const value = parseFloat(e.target.value);
                    setDiscount(value >= 0 ? value : 0); // disallow negative
                    }}
                />
                </div>



             <div className='col-lg-12 d-flex justify-content-between mb-4'>
            <label className='text-black font-w500 fs-5'>Discount Amount</label>
            <label className='text-black font-w500 fs-4'>₹ {computedDiscountAmount.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</label>
            </div>
            <div className='col-lg-12 d-flex justify-content-between mb-4'>
            <label className='text-black font-w500 fs-5'>GST (%)</label>
            <input
                type="number"
                min="0"
                className="form-control text-end text-black font-w500"
                placeholder="GST"
                style={{ width: '30%' }}
                value={gst}
                onChange={(e) => {
                    const value = parseFloat(e.target.value);
                    setGst(value >= 0 ? value : 0); // disallow negative
                }}
                />

            </div> 
            <div className='col-lg-12 d-flex justify-content-between mb-4'>
            <label className='text-black font-w500 fs-5'>GST Amount</label>
            <label className='text-black font-w500 fs-4'>₹ {computedGstAmount.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</label>
            </div>

            <div className='col-lg-12 d-flex justify-content-between mb-4'>
            <label className='text-danger font-w500 fs-5'>Total Amount</label>
            <label className='text-danger font-w500 fs-4'>₹ {computedTotalAmount.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</label>
            </div>

          </div>
        </div>
      </div>

      <div className="d-flex align-items-center justify-content-end gap-3 mt-4">
        <Link to={'/manage-purchase'} className="btn btn-sm btn-secondary">Cancel</Link>
        <button onClick={ConfirmationModal} className="btn btn-sm btn-primary">Verify</button>
      </div>
    </>
  );
};

export default AmountEntry;
